var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQuoteStart = function SvgQuoteStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.225 14.355c0 10-7.42 20.646-18.226 27.581-1.774 1.13-2.742 1.13-3.71-.161l-.806-1.13c-.807-1.128-.645-1.773.806-3.064 3.065-2.742 8.226-8.548 8.226-12.58 0-4.033-4.032-6.936-4.032-10.969C5.483 8.387 9.838 5 14.515 5c5.323 0 8.71 3.871 8.71 9.355zm26.775 0c0 10-7.42 20.646-18.226 27.581-1.774 1.13-2.742 1.13-3.71-.161l-.806-1.13c-.807-1.128-.646-1.773.806-3.064 3.065-2.742 8.226-8.548 8.226-12.58 0-4.033-4.032-6.936-4.032-10.969C32.258 8.387 36.613 5 41.29 5 46.613 5 50 8.871 50 14.355z"
  })));
};

export default SvgQuoteStart;